import {
	ADMINDELETEINTEGRATION_SUCCESS,
	ADMINDELETEINTEGRATION_FAILED,
	RESET_ADMINDELETEINTEGRATION,
	LOADING_ADMINDELETEINTEGRATION,
	NETWORK_ERROR_ADMINDELETEINTEGRATION
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminDeleteIntegration = () => {
	return { type: RESET_ADMINDELETEINTEGRATION };
};

const adminDeleteIntegration = (userData, authTokenIs) => async (dispatch) => {
	dispatch({ type: LOADING_ADMINDELETEINTEGRATION });
	await adminServices
		.post("deleteIntegration", userData, { headers: { AuthToken: authTokenIs } })
		.then((res) => {
			switch (res.data.status) {
				case "success":
					dispatch(adminDeleteIntegrationsuccess(res.data));
					break;
				default:
					dispatch(adminDeleteIntegrationFailed(res.data));
					break;
			}
		})
		.catch((err) => {
			dispatch({
				type: NETWORK_ERROR_ADMINDELETEINTEGRATION,
				payload: err
			});
		});
};
function adminDeleteIntegrationsuccess(data) {
	return {
		type: ADMINDELETEINTEGRATION_SUCCESS,
		payload: data
	};
}
function adminDeleteIntegrationFailed(data) {
	return {
		type: ADMINDELETEINTEGRATION_FAILED,
		payload: data
	};
}

export { resetAdminDeleteIntegration, adminDeleteIntegration };
